import {OrderDirectionType, SortUiState} from './SortUiState.model';

export enum CRE_BANK_ACCOUNTS_ALLOWED_ORDER_BY {
  investingEntity = 'investingEntity',
  holderFullName = 'holderFullName',
  currency = 'currency',
  paymentType = "paymentType",
  country = "country"
}

export class CreBankAccountsUiState {
  private static ORDER_BY_DEFAULT: string = CRE_BANK_ACCOUNTS_ALLOWED_ORDER_BY.holderFullName;
  private static DIRECTION_DEFAULT: OrderDirectionType = 'asc';

  public sort: SortUiState;

  constructor() {
    this.sort = {
      orderBy: CreBankAccountsUiState.ORDER_BY_DEFAULT,
      direction: CreBankAccountsUiState.DIRECTION_DEFAULT
    };
  }

  static fromJson(contactsObj: any): CreBankAccountsUiState {
    const model = new CreBankAccountsUiState();
    if (contactsObj && contactsObj.sort) {
      model.sort = {
        orderBy: contactsObj.sort.orderBy || CreBankAccountsUiState.ORDER_BY_DEFAULT,
        direction: contactsObj.sort.direction || CreBankAccountsUiState.DIRECTION_DEFAULT
      };
    }
    return model;
  }
}
